/**
 * 화폐 관련 유틸리티
 * 투어 잔금(balance) 화폐 표시에 사용
 */

// depositRate: 잔금(해당 화폐) 1단위당 자동 산정되는 예약금(KRW) = 환율 × 예약금 비율(10%)
//   - USD: 1500원/$ × 10% = 150
//   - JPY: 1000원/100엔(=10원/엔) × 10% = 1
//   - KRW: 1 × 10% = 0.1
//   - PHP: 25원/₱ × 10% = 2.5
// decimals: 화폐 관례에 따른 소수점 자릿수 (원·엔 0자리, 달러·페소 2자리)
export const CURRENCY_OPTIONS = [
    { code: 'USD', label: '달러 (USD)', symbol: '$', unit: '달러', prefix: true, depositRate: 150, decimals: 2 },
    { code: 'JPY', label: '엔 (JPY)', symbol: '¥', unit: '엔', prefix: true, depositRate: 1, decimals: 0 },
    { code: 'KRW', label: '원 (KRW)', symbol: '₩', unit: '원', prefix: false, depositRate: 0.1, decimals: 0 },
    { code: 'PHP', label: '페소 (PHP)', symbol: '₱', unit: '페소', prefix: true, depositRate: 2.5, decimals: 2 },
];

export const getCurrencyConfig = (code) =>
    CURRENCY_OPTIONS.find((c) => c.code === code) || CURRENCY_OPTIONS[0];

// 잔금과 화폐로부터 예약금(KRW)을 자동 산정한다. 원 단위 반올림.
export const calcDepositFromBalance = (balance, currency) => {
    const amount = Number(balance) || 0;
    if (amount <= 0) return 0;
    return Math.round(amount * getCurrencyConfig(currency).depositRate);
};

// 입력 중인 금액 문자열에 천 단위 콤마를 붙인다(소수점은 화폐 자릿수까지 유지, 타이핑 중 trailing dot 허용).
// 콤마가 제거된 raw 문자열을 받아 표시용 문자열을 반환한다.
export const formatAmountInput = (raw, currency) => {
    const decimals = getCurrencyConfig(currency).decimals;
    if (!raw) return '';
    // 소수점 미사용 화폐는 점 이후를 버린다.
    if (decimals === 0) {
        const intOnly = raw.split('.')[0].replace(/\D/g, '');
        return intOnly ? Number(intOnly).toLocaleString('ko-KR') : '';
    }
    const [intPartRaw, ...rest] = raw.split('.');
    const intPart = intPartRaw.replace(/\D/g, '');
    const intFormatted = intPart ? Number(intPart).toLocaleString('ko-KR') : '0';
    if (rest.length === 0) return intPart ? intFormatted : ''; // 점 없음
    // 점이 하나 이상 있으면 첫 점만 인정하고 소수 자릿수 제한
    const decPart = rest.join('').replace(/\D/g, '').slice(0, decimals);
    return `${intFormatted}.${decPart}`;
};

// 저장된 숫자값을 화폐 관례대로 표시한다(blur·로드 시).
export const formatAmountDisplay = (value, currency) => {
    const num = Number(value) || 0;
    if (!num) return '';
    const decimals = getCurrencyConfig(currency).decimals;
    return num.toLocaleString('ko-KR', { minimumFractionDigits: 0, maximumFractionDigits: decimals });
};

